// extracted by mini-css-extract-plugin
export default {"circle":"DefaultTrigger_circle__ASKFe","icon":"DefaultTrigger_icon__I4Fe8"};